import { useEffect } from 'react';

import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import { AppProcessSteps, useAppProgressBar } from 'hooks/useAppProgressBar';
import { useCurrentStep } from 'hooks/useCurrentStep';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';

import AcceptLegalDocumentsStep from './AcceptLegalDocumentsStep';
import CreditAndAutoOriginationCheckStep from './CreditAndAutoOriginationCheckStep';
import IncomeSourcesStep from './IncomeSourcesStep';
import { ApplicationDetailsSubmissionSteps } from './constants';

const ApplicationDetailsSubmissionStep = () => {
  const trackEvent = useGoogleAnalytics();
  const [currentStep, setCurrentStep] = useCurrentStep<ApplicationDetailsSubmissionSteps>(
    ApplicationDetailsSubmissionSteps.IncomeSourcesStep,
  );
  const { setProgressStep, resetProgress } = useAppProgressBar();

  useEffect(() => {
    const updateProgressBar = () => {
      switch (currentStep) {
        case ApplicationDetailsSubmissionSteps.IncomeSourcesStep:
          setProgressStep(AppProcessSteps.IncomeInformationStep);
          trackEvent(GoogleAnalyticsEventType.ApplyProcessIncome);
          break;
        case ApplicationDetailsSubmissionSteps.AcceptLegalDocumentsStep:
          setProgressStep(AppProcessSteps.AcceptLegalDocumentsStep);
          trackEvent(GoogleAnalyticsEventType.ApplyProcessConsent);
          break;
        case ApplicationDetailsSubmissionSteps.CreditAndAutoOriginationCheckStep:
          resetProgress();
          break;
        default:
          return;
      }
    };

    updateProgressBar();
  }, [currentStep]);

  const renderStep = () => {
    switch (currentStep) {
      case ApplicationDetailsSubmissionSteps.IncomeSourcesStep:
        return (
          <IncomeSourcesStep
            onStepComplete={() =>
              setCurrentStep(ApplicationDetailsSubmissionSteps.AcceptLegalDocumentsStep)
            }
          />
        );
      case ApplicationDetailsSubmissionSteps.AcceptLegalDocumentsStep:
        return (
          <AcceptLegalDocumentsStep
            onStepComplete={() => {
              setCurrentStep(ApplicationDetailsSubmissionSteps.CreditAndAutoOriginationCheckStep);
            }}
          />
        );
      case ApplicationDetailsSubmissionSteps.CreditAndAutoOriginationCheckStep:
        return <CreditAndAutoOriginationCheckStep />;
      default:
        return null as never;
    }
  };
  return renderStep();
};

export default ApplicationDetailsSubmissionStep;
